export enum ButtonMessage {
  COPYLINK = 'Copy link',
  COPY = 'Copy',
  COPYING = 'Copying',
  COPIED = 'Copied',
  ERROR = 'Error. Try again',
  BUTTONROLE = 'status',
}

export enum TrackingMessage {
  COPYLINK = 'copyArticleLink',
}

export const link = 'https://www.decentraland.org/docs/';

export const copyLinkDetails = {
  isSuccessful: false,
  message: '',
};

export const ESCAPE_KEY = 'Escape';
